import store from '@sb/store'
import lo from 'lodash'
import sb from '@sb/util'
import {i18n} from '../languages.js'

export function getTicketViewName(view, options = {fallback: true, shorten: false}) {
	let id = lo.get(view, 'id') || ''
	if (id.startsWith('tvdefault_type_')) {
		let typeid = getTypeIdFromViewId(id)
		let prefix = getTicketTypeName(store.matchTicketType()[typeid]) + ' - '
		if (options.shorten) prefix = ''
		if (id.endsWith('myview')) return prefix + i18n.t('mine')
		if (id.endsWith('allview')) return prefix + i18n.t('all')
		if (id.endsWith('unassign')) return prefix + i18n.t('unassigned_short')
		if (id.endsWith('follow')) return prefix + i18n.t('follow')
	}
	if (id.startsWith('tvdefault')) {
		if (id === `tvdefault_${store.me().id}_myview`) return i18n.t('mine')
		if (id === `tvdefault_${store.me().id}_unassign`) return i18n.t('unassigned_short')
		if (id === `tvdefault_${store.me().id}_follow`) return i18n.t('follow')
		if (id === `tvdefault_${store.me().id}_inbox`) return i18n.t('inbox2')
	}

	if (options.fallback) {
		if (options.fallback === true) return view.name || i18n.t('untitled')
		return view.name || fallback
	}
	return view.name || ''
}

export function getTypeIdFromViewId(viewid = '') {
	if (!viewid.startsWith('tvdefault_type_')) return ''
	let typeids = lo.split(viewid, '_')
	let typeid = lo.get(typeids, '2')
	if (typeid === 'ttdefault') typeid = typeid + '_' + lo.get(typeids, '3')
	return typeid
}

export function getTicketTypeName(type = {}) {
	let id = type.id || ''
	if (id.startsWith('ttdefault') && !lo.trim(type.name)) return i18n.t('default')
	return type.name
}

export const extractLexicalHtml = lo.memoize(function (text, options) {
	let plaintext = sb.lexicalToPlainText(text, options)
	return sb.extractText(plaintext)
})

export const getTicketStateInfo = (ticket) => {
	if (ticket.state === 'open') {
		return {
			type: 'success',
			text: i18n.t('ticket_status_open'),
		}
	}
	if (ticket.state === 'hold') {
		return {
			type: 'primary',
			text: i18n.t('ticket_status_hold'),
		}
	}
	if (ticket.state === 'closed') {
		return {
			type: 'secondary',
			text: i18n.t('ticket_status_closed'),
		}
	}

	return {
		type: 'warning',
		text: i18n.t('ticket_status_unassigned'),
	}
}

export const ORDERED_GENERAL_VIEW_SUFFIXES = ['allview', 'inbox','myview', 'follow', 'unassign']

export const canViewTicket = (ticket = {}) => {
	let meid = store.me().id
	if (meid === ticket.reporter) return true
	if (meid === ticket.assignee) return true
	let typeid = ticket.type_id
	let type = store.matchTicketType()[typeid] || {}
	if (lo.find(type.members, (mem) => mem.id === meid)) return true
	return lo.find(ticket.members, (mem) => mem.id === meid)
}

export const isTicketUnread = (ticket = {}) => {
	if (typeof ticket !== 'object') return false
	let lastEv = ticket.last_event
	if (!lastEv) return false

	let byid = lo.get(lastEv, 'by.id')
	if (byid === store.me().id) return false

	let members = ticket.members
	let meag = lo.find(members, (mem) => mem.id === store.me().id)
	if (meag && typeof meag === 'object' && lastEv.created) {
		if ((meag.read_at || 0) < lastEv.created) return true
	}

	return false
}
